import React from 'react';
import PropTypes from 'prop-types';
import { MenuLeafNode } from './menu-nodes/MenuLeafNode';
import { MenuParentNode } from './menu-nodes/MenuParentNode';
import { I18nUtils } from '../../../../../../../i18n/I18nUtils';
import { PsRoutes } from '../../../../../routing/Routes';

export const MyOutsourcesManagerMenu = (
    {
        displayTasks,
        displayListerias,
    },
) => {
    return (
        <React.Fragment>
            <MenuLeafNode
                icon={'home'}
                label={I18nUtils.tr('TR_INICIO')}
                route={PsRoutes.HOME}
                activeRoutes={[PsRoutes.HOME]}
            />
            <MenuParentNode
                icon={'work_outline'}
                label={I18nUtils.tr('TR_MIS_SUBCONTRATAS')}
                activeRoutes={[
                    PsRoutes.MY_OUTSOURCES,
                    PsRoutes.MY_OUTSOURCES_DETAIL,
                    PsRoutes.MY_OUTSOURCES_WORKERS,
                    PsRoutes.MY_OUTSOURCES_WORKERS_DETAIL,
                    PsRoutes.MY_OUTSOURCES_WORKERS_DOCUMENTS_DETAIL,
                    PsRoutes.MY_OUTSOURCES_MACHINES,
                    PsRoutes.MY_OUTSOURCES_MACHINES_DETAIL,
                    PsRoutes.MY_OUTSOURCES_MACHINES_DOCUMENTS_DETAIL,
                    PsRoutes.MY_OUTSOURCES_DOCUMENTS,
                    PsRoutes.MY_OUTSOURCES_DOCUMENTS_DETAIL,
                    PsRoutes.MY_OUTSOURCES_WORKS,
                    PsRoutes.MY_OUTSOURCES_WORKS_ADD,
                    PsRoutes.MY_OUTSOURCES_WORKS_DETAIL,
                    PsRoutes.MY_OUTSOURCES_MONTHLY,
                    PsRoutes.MY_OUTSOURCES_TASKS,
                    PsRoutes.MY_OUTSOURCES_PRESENCES_MONTHLY,
                    PsRoutes.MY_OUTSOURCES_PRESENCES_MONTHLY,
                    PsRoutes.MY_OUTSOURCES_PRESENCES_WORKS,
                    PsRoutes.MY_OUTSOURCES_PRESENCES_WORKS_DETAIL,
                ]}
            >
                <MenuLeafNode
                    label={I18nUtils.tr('TR_TODAS_LAS_SUBCONTRATAS')}
                    route={PsRoutes.MY_OUTSOURCES}
                    activeRoutes={[PsRoutes.MY_OUTSOURCES, PsRoutes.MY_OUTSOURCES_DETAIL]}
                />
                <MenuLeafNode
                    label={I18nUtils.tr('TR_DOCUMENTOS')}
                    route={PsRoutes.MY_OUTSOURCES_DOCUMENTS}
                    activeRoutes={[
                        PsRoutes.MY_OUTSOURCES_DOCUMENTS,
                        PsRoutes.MY_OUTSOURCES_DOCUMENTS_DETAIL,
                        PsRoutes.MY_OUTSOURCES_WORKERS_DOCUMENTS_DETAIL,
                        PsRoutes.MY_OUTSOURCES_MACHINES_DOCUMENTS_DETAIL,
                    ]}
                />
                <MenuLeafNode
                    label={I18nUtils.tr('TR_TRABAJADORES')}
                    route={PsRoutes.MY_OUTSOURCES_WORKERS}
                    activeRoutes={[PsRoutes.MY_OUTSOURCES_WORKERS, PsRoutes.MY_OUTSOURCES_WORKERS_DETAIL]}
                />
                <MenuLeafNode
                    label={I18nUtils.tr('TR_MAQUINARIA')}
                    route={PsRoutes.MY_OUTSOURCES_MACHINES}
                    activeRoutes={[PsRoutes.MY_OUTSOURCES_MACHINES, PsRoutes.MY_OUTSOURCES_MACHINES_DETAIL]}
                />
                <MenuParentNode
                    label={I18nUtils.tr('TR_OBRAS')}
                    activeRoutes={[
                        PsRoutes.MY_OUTSOURCES_WORKS,
                        PsRoutes.MY_OUTSOURCES_WORKS_ADD,
                        PsRoutes.MY_OUTSOURCES_WORKS_DETAIL,
                    ]}
                >
                    <MenuLeafNode
                        label={I18nUtils.tr('TR_NUEVA_OBRA')}
                        route={PsRoutes.MY_OUTSOURCES_WORKS_ADD}
                        activeRoutes={[PsRoutes.MY_OUTSOURCES_WORKS_ADD]}
                    />
                    <MenuLeafNode
                        label={I18nUtils.tr('TR_TODAS_LAS_OBRAS')}
                        route={PsRoutes.MY_OUTSOURCES_WORKS}
                        activeRoutes={[PsRoutes.MY_OUTSOURCES_WORKS, PsRoutes.MY_OUTSOURCES_WORKS_DETAIL]}
                    />
                </MenuParentNode>
                <MenuLeafNode
                    label={I18nUtils.tr('TR_MENSUAL')}
                    route={PsRoutes.MY_OUTSOURCES_MONTHLY}
                    activeRoutes={[PsRoutes.MY_OUTSOURCES_MONTHLY]}
                />
                {displayListerias &&
                    <MenuParentNode
                        label={I18nUtils.tr('TR_LISTERIAS')}
                        activeRoutes={[
                            PsRoutes.MY_OUTSOURCES_PRESENCES_MONTHLY,
                            PsRoutes.MY_OUTSOURCES_PRESENCES_WORKS,
                            PsRoutes.MY_OUTSOURCES_PRESENCES_WORKS_DETAIL,
                        ]}
                    >
                        <MenuLeafNode
                            label={I18nUtils.tr('TR_LISTERIA_MENSUAL')}
                            route={PsRoutes.MY_OUTSOURCES_PRESENCES_MONTHLY}
                            activeRoutes={[PsRoutes.MY_OUTSOURCES_PRESENCES_MONTHLY]}
                        />
                        <MenuLeafNode
                            label={I18nUtils.tr('TR_GESTIONAR_PRESENCIAS')}
                            route={PsRoutes.MY_OUTSOURCES_PRESENCES_WORKS}
                            activeRoutes={[PsRoutes.MY_OUTSOURCES_PRESENCES_WORKS, PsRoutes.MY_OUTSOURCES_PRESENCES_WORKS_DETAIL]}
                        />
                    </MenuParentNode>
                }
                {
                    displayTasks ? (
                        <MenuLeafNode
                            label={I18nUtils.tr('TR_TAREAS')}
                            route={PsRoutes.MY_OUTSOURCES_TASKS}
                            activeRoutes={[PsRoutes.MY_OUTSOURCES_TASKS]}
                        />
                    ) : null
                }
            </MenuParentNode>
        </React.Fragment>
    );
};

MyOutsourcesManagerMenu.propTypes = {
    contractor: PropTypes.object.isRequired,
    displayTasks: PropTypes.bool.isRequired,
    displayListerias: PropTypes.bool.isRequired,
};

MyOutsourcesManagerMenu.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/shared/components/layout/sidebar/menu/menus-by-role/MyOutsourcesManagerMenu.jsx